export default {
  specialCategories: [],
  category: {},
  defaultCategory: {},
}
